export default __webpack_public_path__ + "static/media/navLogo.38f0270b.png";